'use client';

import { Sanitizer } from '@components/sanitizer';
import { Typography, TypographyVariant } from '@components/typography';
import { classNames } from '@lib/classNames/classNames';
import { PropsWithChildren } from 'react';

interface PageSectionProps {
  rootClassName?: string;
  title?: string;
  titleId?: string;
  titleMaxWidth?: number;
  description?: string;
  descriptionId?: string;
  descriptionMaxWidth?: number;
  descriptionClassName?: string;
  childrenWrapperClassName?: string;
  titleClassName?: string;
  titleVariant?: TypographyVariant;
}

export const PageSection = ({
  rootClassName,
  title,
  titleId,
  titleClassName,
  titleMaxWidth,
  description,
  descriptionId,
  descriptionClassName,
  descriptionMaxWidth = 872,
  childrenWrapperClassName,
  children,
  titleVariant = 'heading-l',
}: PropsWithChildren<PageSectionProps>) => {
  const hasTitleOrDescription = title || description;

  return (
    <div
      className={classNames({
        cls: 'm-auto mt-30 max-w-[1200px] max-sm:mt-16',
        additional: [rootClassName],
      })}
    >
      {hasTitleOrDescription && (
        <div className="px-4 whitespace-pre-line">
          {title && (
            <Typography
              id={titleId}
              variant={titleVariant}
              style={{ maxWidth: titleMaxWidth }}
              className={classNames({
                mods: { 'max-sm:pb-3 md:pb-5': !!description },
                additional: [titleClassName],
              })}
            >
              <Sanitizer htmlContent={title} />
            </Typography>
          )}
          {description && (
            <Typography
              id={descriptionId}
              variant="text-m"
              style={{ maxWidth: descriptionMaxWidth }}
              className={classNames({
                additional: [descriptionClassName],
              })}
            >
              {description}
            </Typography>
          )}
        </div>
      )}
      <div
        className={classNames({
          mods: {
            'mt-12 max-sm:mt-9': hasTitleOrDescription,
          },
          additional: [childrenWrapperClassName],
        })}
      >
        {children}
      </div>
    </div>
  );
};
